
import { Record } from "../../fable_modules/fable-library-js.5.0.0/Types.js";
import { PortWindWeatherResult_$reflection, SensorMetaData_$reflection, SensorId__get_Value, SensorId_$reflection } from "../../StenaWeather.Domain/PortWind.js";
import { tuple_type, lambda_type, unit_type, bool_type, list_type, record_type, string_type, class_type } from "../../fable_modules/fable-library-js.5.0.0/Reflection.js";
import { escapeDataString } from "../../fable_modules/fable-library-js.5.0.0/Util.js";
import { toString } from "../../fable_modules/fable-library-js.5.0.0/Date.js";
import { concat } from "../../fable_modules/fable-library-js.5.0.0/String.js";

export const Const_MaxItemsInChart = 1000;

export class Request_ExportCsvRequest extends Record {
    constructor(SensorId, Start, End, Filename) {
        super();
        this.SensorId = SensorId;
        this.Start = Start;
        this.End = End;
        this.Filename = Filename;
    }
}

export function Request_ExportCsvRequest_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Shared.PortWind.API.Request.ExportCsvRequest", [], Request_ExportCsvRequest, () => [["SensorId", SensorId_$reflection()], ["Start", class_type("System.DateTimeOffset")], ["End", class_type("System.DateTimeOffset")], ["Filename", string_type]]);
}

export function Request_ExportCsvRequest_get_SensorIdKey() {
    return "sensorId";
}

export function Request_ExportCsvRequest_get_StartKey() {
    return "start";
}

export function Request_ExportCsvRequest_get_EndKey() {
    return "end";
}

export function Request_ExportCsvRequest_get_FilenameKey() {
    return "filename";
}

export function Request_ExportCsvRequest__ToUrl(this$) {
    const startStr = escapeDataString(toString(this$.Start, "o"));
    const endStr = escapeDataString(toString(this$.End, "o"));
    const filenameStr = escapeDataString(this$.Filename);
    const id = SensorId__get_Value(this$.SensorId);
    return `/api/portwind/export-csv?${Request_ExportCsvRequest_get_SensorIdKey()}=${id}&${Request_ExportCsvRequest_get_StartKey()}=${startStr}&${Request_ExportCsvRequest_get_EndKey()}=${endStr}&${Request_ExportCsvRequest_get_FilenameKey()}=${filenameStr}`;
}

export class Response_SensorLastUpdatedInfo extends Record {
    constructor(SensorId, LastUpdated) {
        super();
        this.SensorId = SensorId;
        this.LastUpdated = LastUpdated;
    }
}

export function Response_SensorLastUpdatedInfo_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Shared.PortWind.API.Response.SensorLastUpdatedInfo", [], Response_SensorLastUpdatedInfo, () => [["SensorId", SensorId_$reflection()], ["LastUpdated", class_type("System.DateTimeOffset")]]);
}

export class Response_SensorsLastUpdated extends Record {
    constructor(Sensors, IsFallbackData) {
        super();
        this.Sensors = Sensors;
        this.IsFallbackData = IsFallbackData;
    }
}

export function Response_SensorsLastUpdated_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Shared.PortWind.API.Response.SensorsLastUpdated", [], Response_SensorsLastUpdated, () => [["Sensors", list_type(Response_SensorLastUpdatedInfo_$reflection())], ["IsFallbackData", bool_type]]);
}

export class PortWindAPI extends Record {
    constructor(GetSensors, GetWeather, GetSensorsLastUpdated, CheckAuthByIP) {
        super();
        this.GetSensors = GetSensors;
        this.GetWeather = GetWeather;
        this.GetSensorsLastUpdated = GetSensorsLastUpdated;
        this.CheckAuthByIP = CheckAuthByIP;
    }
}

export function PortWindAPI_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Shared.PortWind.API.PortWindAPI", [], PortWindAPI, () => [["GetSensors", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(SensorMetaData_$reflection())]))], ["GetWeather", lambda_type(SensorId_$reflection(), lambda_type(tuple_type(class_type("System.DateTimeOffset"), class_type("System.DateTimeOffset")), lambda_type(class_type("System.TimeSpan"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [PortWindWeatherResult_$reflection()]))))], ["GetSensorsLastUpdated", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [Response_SensorsLastUpdated_$reflection()]))], ["CheckAuthByIP", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [unit_type]))]]);
}

export function PortWindAPI_RouteBuilder(_arg, m) {
    return concat("/api/portwind/", ...m);
}

export class PortWindPublicAPI extends Record {
    constructor(GetSensors, GetWeather) {
        super();
        this.GetSensors = GetSensors;
        this.GetWeather = GetWeather;
    }
}

export function PortWindPublicAPI_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Shared.PortWind.API.PortWindPublicAPI", [], PortWindPublicAPI, () => [["GetSensors", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(SensorMetaData_$reflection())]))], ["GetWeather", lambda_type(SensorId_$reflection(), lambda_type(tuple_type(class_type("System.DateTimeOffset"), class_type("System.DateTimeOffset")), lambda_type(class_type("System.TimeSpan"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [PortWindWeatherResult_$reflection()]))))]]);
}

export function PortWindPublicAPI_RouteBuilder(_arg, m) {
    return concat("/api/portwind/public/", ...m);
}

